import { useCallback, useEffect, useState } from "react";

import PropTypes from "prop-types";

import {
  Box,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Paper,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";

import { OutletRoleEnum } from "@/features/outlets";
import { apiClient, getErrorMessage } from "@/features/shared";
import { useSnackbar } from "@/features/ui";

const OutletAvailabilitySection = ({ promotion }) => {
  const { showSnackbar } = useSnackbar();
  const [outlets, setOutlets] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const assignedOutletIds = new Set(
    (promotion.promotionOutlets || []).map((o) => o.outletId)
  );

  const loadOutlets = useCallback(async () => {
    setIsLoading(true);
    try {
      const {
        data: { data },
      } = await apiClient.get("/outlets", {
        params: { role: OutletRoleEnum.RETAIL, status: true },
      });
      setOutlets(data);
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal memuat cabang toko"));
    } finally {
      setIsLoading(false);
    }
  }, [showSnackbar]);

  useEffect(() => {
    loadOutlets();
  }, [loadOutlets]);

  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Typography variant="h6" sx={{ mb: 1 }}>
        Outlet
      </Typography>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            mt: 1
          }}>
          <CircularProgress size={24} />
          <Typography variant="body2" sx={{ ml: 1 }}>
            Loading...
          </Typography>
        </Box>
      ) : (
        <Grid container columnSpacing={2.5} rowSpacing={1} sx={{ mt: 1 }}>
          {outlets.map((outlet) => (
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={outlet.id}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={assignedOutletIds.has(outlet.id)}
                    disabled
                  />
                }
                label={outlet.name}
              />
            </Grid>
          ))}
        </Grid>
      )}
    </Paper>
  );
};

OutletAvailabilitySection.propTypes = {
  promotion: PropTypes.object.isRequired,
};

export default OutletAvailabilitySection;
